// The bare context object + hook, kept apart from AppContext.jsx so a page can read it
// without importing the provider (which pulls in the Google Sheets loader and the rest of
// the engine). Hollypaul's AppProvider fills it; a tenant build (src/tenant/TenantApp.jsx)
// fills it with its own small value, so the same page runs on both.
import { createContext, useContext } from 'react';

export const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);
